import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { CreditPullTiersManagement } from '../components/creditPullTiersManagement/creditPullTiersManagement';

export const getCreditPullTiersRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    creditPullTiersManagement: {
      path: `${basePath}/credit-pull-tiers`,
      url: `${baseUrl}/credit-pull-tiers`,
      documentTitle: 'Credit Pull Tiers Management',
    },
  };
};

export const getCreditPullTiersRoutes = (basePath: string, baseUrl: string) => {
  const config = getCreditPullTiersRoutesConfig(basePath, baseUrl);

  return {
    creditPullTiersManagement: (
      <Route exact path={config.creditPullTiersManagement.path}>
        <Page routeDefinition={config.creditPullTiersManagement}>
          <CreditPullTiersManagement />
        </Page>
      </Route>
    ),
  };
};
